export const styles =
  '[&_.MuiInputBase-root_.MuiInputBase-input]:h-14 [&_.MuiInputBase-input]:box-border [&_.MuiInputBase-input]:p-md';
